module.exports = __webpack_public_path__ + "img/text-input-dark-01.16b7df9b.png";